import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { FeatureFlagsApi } from '~/core/api';
import { isFeatureEnabled } from '~/core/utils/isFeatureEnabled';
import showError from '~/bridge/showError';
import useMainStore from '~/stores/useMainStore';
import useCountriesStore from '~/stores/useCountriesStore';
export default defineNuxtRouteMiddleware(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to) {
    var mainStore, _useNuxtApp, $captureException, countryIso, _to$meta, meta, _countriesStore$selec, countriesStore, _yield$FeatureFlagsAp, featureFlags;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          mainStore = useMainStore();
          _useNuxtApp = useNuxtApp(), $captureException = _useNuxtApp.$captureException;
          _context.prev = 2;
          meta = ((_to$meta = to.meta) === null || _to$meta === void 0 ? void 0 : _to$meta[0]) || {}; // NOTE: Используется для ограничения доступа к роутам по флагу, передаваемому в meta
          if (!meta.useCountryParamForFeatureFlags) {
            _context.next = 9;
            break;
          }
          countriesStore = useCountriesStore();
          _context.next = 8;
          return countriesStore.fetchCountries();
        case 8:
          countryIso = (_countriesStore$selec = countriesStore.selectedCountry) === null || _countriesStore$selec === void 0 ? void 0 : _countriesStore$selec.iso;
        case 9:
          _context.next = 11;
          return FeatureFlagsApi.get({
            countryIso: countryIso
          });
        case 11:
          _yield$FeatureFlagsAp = _context.sent;
          featureFlags = _yield$FeatureFlagsAp.data;
          mainStore.featureFlags = featureFlags;
          if (!isFeatureEnabled(meta.featureFlag, featureFlags)) {
            showError({
              statusCode: 403,
              message: 'Forbidden'
            });
          }
          _context.next = 20;
          break;
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](2);
          $captureException(_context.t0);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 17]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());